import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-stone-200/70 mt-16"
            style={{ background: "rgba(253,251,247,0.6)", backdropFilter: "blur(10px)" }}
            data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <div className="font-display text-xl">LoomPDF</div>
          <p className="text-stone-500 text-sm mt-1">
            Operated by Min3rva.org
          </p>
          <p className="text-stone-400 text-xs mt-0.5">
            © {new Date().getFullYear()} LoomPDF. All rights reserved.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-stone-600">
          <Link to="/pricing" className="hover:text-stone-900" data-testid="footer-pricing">Pricing</Link>
          <a href="mailto:support@loompdf.com?subject=Loom%20Support%20request&body=Hi%20Loom%20team%2C%0A%0AI%20need%20help%20with%3A%20(PDF%20%2F%20payment%20%2F%20other)%0A%0AMy%20account%20email%3A%20%0A%0ADetails%3A%20"
             className="hover:text-stone-900" data-testid="footer-support">Support</a>
          <Link to="/terms" className="hover:text-stone-900" data-testid="footer-terms">Terms</Link>
          <Link to="/privacy" className="hover:text-stone-900" data-testid="footer-privacy">Privacy</Link>
          <Link to="/refund" className="hover:text-stone-900" data-testid="footer-refund">Refund &amp; Cancellation</Link>
          <Link to="/contact" className="hover:text-stone-900" data-testid="footer-contact">Contact Us</Link>
        </nav>
      </div>
    </footer>
  );
}
